import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    margin: 5,
  },
  list: {
    minHeight: '85%',
    width: '96%',
    margin: 5,
  },
  listContainer: {
    position: 'relative',
    maxHeight: '85%',
    overflowY: 'auto'
  },
  searchInput: {
    width: '70%',
    margin: '10px 0 20px 10px'
  },
  panel: {
    minHeight: '12%',
    margin: 5,
  },
  chatContainer: {
    width: '96%',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    margin: 5,
    padding: theme.spacing(2),
  },
  messageContainer: {
    marginBottom: theme.spacing(2),
    // paddingTop: '30px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'relative'
  },
  messageBubble: {
    minWidth: '120px',
    padding: '30px 10px 10px',
    // padding: '20px 10px 10px 10px',
    borderRadius: '10px',
    background: '#E8E8E8'
  },
  messageImgContainer: {
    height: 'auto',
    padding: '30px 10px 10px',
    marginBottom: theme.spacing(2),
    borderRadius: '10px',
    background: '#E8E8E8',
    position: 'relative'
  },
  messageFileContainer: {
    height: 'auto',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
    borderRadius: '10px',
    background: '#E8E8E8',
    position: 'relative'
  },
  img: {
    // width: '200px',
    height: '200px',
    borderRadius: '4px'
  },
  fileImg: {
    width: '120px',
    height: '100px'
  },
  nameTxt: {
    fontSize: '14px'
  },
  btnDownload: {
    width: '32px',
    height: '32px'
  },
  inputContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    // marginTop: theme.spacing(1),
  },
  textField: {
    flexGrow: 1,
    marginRight: theme.spacing(2),
  },
  fileInput: {
    display: 'none',
  },
  fileButton: {
    // marginLeft: theme.spacing(2),
  },
  fileName: {
    maxWidth: '100px',
    maxHeight: '32px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  cancelBtn: {
    width: '36px',
    height: '36px',
    position: 'absolute',
    right: '4px',
    top: 0,
  }
}))
